import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Paper, Grid, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { ApiRequest } from '../../services/api'; // Ajusta la ruta según tu estructura

const NewBanner = () => {
  const [recipes, setRecipes] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState('');
  const [description, setDescription] = useState('');
  const [imageBase64, setImageBase64] = useState(''); // Almacena la imagen en Base64
  const [recipeDetails, setRecipeDetails] = useState(null);
  const navigate = useNavigate(); // Usar para redirigir después de crear el banner

  // Cargar las recetas al montar el componente
  useEffect(() => {
    const loadRecipes = async () => {
      try {
        const data = await ApiRequest("api/Recetas/"); // Ajusta la ruta si es necesario
        setRecipes(data || []);
      } catch (error) {
        console.error("Error fetching recetas:", error);
      }
    };

    loadRecipes();
  }, []);

  // Cargar los detalles de la receta seleccionada
  useEffect(() => {
    if (selectedRecipe) {
      const loadRecipeDetails = async () => {
        try {
          const data = await ApiRequest(`api/Recetas/${selectedRecipe}`);
          setRecipeDetails(data);
        } catch (error) {
          console.error("Error fetching receta details:", error);
        }
      };

      loadRecipeDetails();
    }
  }, [selectedRecipe]);

  // Manejar la conversión de imagen a Base64
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        // Extraer solo la parte Base64 eliminando el prefijo "data:image/jpeg;base64,"
        //const base64Image = base64String.split(',')[1];
        setImageBase64(base64String); // Almacena la imagen en Base64 completa (incluyendo el prefijo 'data:image/...base64')
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const bannerData = {
      RecetaId: selectedRecipe,
      DescripcionCorta: description,
      ImagenBanner64: imageBase64.split(',')[1] // Enviar solo la parte Base64
    };

    try {
      // Realizar la solicitud POST para agregar un nuevo banner
      await ApiRequest("api/Banner/AgregarBanner", 'POST', bannerData);
      alert("Banner creado exitosamente!");
      navigate('/dashboard/banners'); // Redirige a la lista de banners o a cualquier otra página
    } catch (error) {
      console.error("Error creating banner:", error);
      alert("Error al crear el banner.");
    }
  };

  return (
    <Paper style={{ padding: 20, maxWidth: 600, margin: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Crear Nuevo Banner
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Seleccionar Receta</InputLabel>
              <Select
                value={selectedRecipe || ''}  // Asegurarse de que siempre tenga un valor definido
                onChange={(e) => setSelectedRecipe(e.target.value)}
                label="Seleccionar Receta"
                required
              >
                {recipes.map((recipe) => (
                  <MenuItem key={recipe.id} value={recipe.id}>
                    {recipe.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {recipeDetails && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6">Detalles de la Receta</Typography>
                <Typography><strong>Nombre:</strong> {recipeDetails.nombre}</Typography>
                <Typography><strong>Descripción:</strong> {recipeDetails.descripcion}</Typography>
                <Typography><strong>Tiempo de Preparación:</strong> {recipeDetails.tiempoPreparacion} minutos</Typography>
                {/*<Typography><strong>Tiempo de Cocción:</strong> {recipeDetails.tiempoCoccion} minutos</Typography>
                <Typography><strong>Porciones:</strong> {recipeDetails.porciones}</Typography>*/}                {/*recipeDetails.urlImagen && (
                  <img
                    src={recipeDetails.urlImagen}
                    alt={recipeDetails.nombre}
                    style={{ width: '100%', maxWidth: 400, height: 'auto', marginTop: 10 }}
                  />
                )*/}
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <TextField
              label="Descripción Corta"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <button class="upload-file-button">
              <svg
                aria-hidden="true"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-width="2"
                  stroke="#fffffff"
                  d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                  stroke-linejoin="round"
                  stroke-linecap="round"
                ></path>
                <path
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  stroke-width="2"
                  stroke="#fffffff"
                  d="M17 15V18M17 21V18M17 18H14M17 18H20"
                ></path>
              </svg>
              Cargar Imagen
              <input type="file" accept="image/*" onChange={handleImageChange} />
            </button>
            {imageBase64 && (
              <>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
                  Vista previa de la imagen:
                </Typography>
                <img
                  src={imageBase64}
                  alt="Vista previa del banner"
                  style={{ width: '100%', maxWidth: 400, height: 'auto', marginTop: 10 }}
                />
              </>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              Crear Banner
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default NewBanner;
